// Saved analyses API service. Communicates with the same-origin Cloudflare
// Pages Functions (/api/analyses) backed by D1.

export interface SavedAnalysisSummary {
  id: string;
  name: string;
  granularity: string | null;
  start_date: string | null;
  end_date: string | null;
  property_count: number;
  total_net_cashflow: number;
  created_at: string;
}

export interface SavedAnalysis extends SavedAnalysisSummary {
  request: any;
  result: any;
}

export interface SaveAnalysisInput {
  name: string;
  granularity?: string;
  start_date?: string;
  end_date?: string;
  property_count?: number;
  total_net_cashflow?: number;
  request?: any;
  result: any;
}

export const analysesAPI = {
  async list(): Promise<SavedAnalysisSummary[]> {
    const res = await fetch('/api/analyses');
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },

  async get(id: string): Promise<SavedAnalysis> {
    const res = await fetch(`/api/analyses/${id}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },

  async save(payload: SaveAnalysisInput): Promise<SavedAnalysisSummary> {
    const res = await fetch('/api/analyses', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => null);
      throw new Error(body?.error || `HTTP ${res.status}`);
    }
    return res.json();
  },

  async remove(id: string): Promise<void> {
    const res = await fetch(`/api/analyses/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
  },
};
